import { gql } from "@apollo/client";

export const RETRY_PARTNER_SYNCHRONIZATION = gql`
  mutation retryPartnerSynchronization($partnerId: Int!) {
    retryPartnerSynchronization(partnerId: $partnerId) {
      partnerId
      synchronizationCompleted
    }
  }
`;
